<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Periodos de Cobro</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="data_periodos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <PeriodoPagoForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      />
    </modal>
  </div>
</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import PeriodoPagoForm from "./PeriodoPagoForm.vue";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";

export default {
  name: "PeriodoPagoCRUD",
  components: {
    uvDataTable,
    PeriodoPagoForm,
    modal,
  },
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      access: [],
      gruposCliente: [],
      showModal: false,
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addPeriodo",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarPeriodo",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deletePeriodo",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Pagos al año",
            value: "Pagos",
          },
          {
            text: "Días de prorroga",
            value: "Prorroga",
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      claims: {},
      data_periodos: [],
      data_clientes: [],
      selectedMenu: 1,
    };
  },
  computed: {},
  methods: {
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createPeriodo(data);
      } else if (doAction == "EDIT") {
        this.editarPeriodo(data);
      }
    },
    async getUserGroups() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("PDV/GruposCliente")
      let arrayGrupos = Object.entries(data.val());
      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ value: element[0], text: element[1]["Nombre"] });
      });
      this.gruposCliente = grupos;
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addPeriodo") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar periodo de cobro");
        this.toggleModal(true);
      }
      if (buttonId == "editarPeriodo") {
        this.idSelected = idSelected[0];
        const cashier = this.$pgsHelper.getById(
          this.data_periodos,
          "Id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cashier;
        this.$refs.modalForm.setTitle("Editar periodo de cobro");
        this.toggleModal(true);
      }
      if (buttonId == "deletePeriodo") {
        this.deletePeriodo(idSelected[0]);
      }
    },
    createPeriodo(data) {
      this.$alert.alertConfirm(
        {
          action:"guardar",
          obj:"el periodo de cobro",
          route:'MBS-Periodos-createPeriodo',
          data:data,
          onSuccess:()=>{
            this.data_periodos = PeriodosCobro.getPeriodosCobroList()
            this.toggleModal(false);
          }
        })
    },
    editarPeriodo(data) {
      this.$alert.alertConfirm(
        {
          action:"editar",
          obj:"el periodo de cobro",
          route:'MBS-Periodos-updatePeriodo',
          data:data,
          onSuccess:()=>{
            this.data_periodos = PeriodosCobro.getPeriodosCobroList()
            this.toggleModal(false);
          }
      })
    },
    deletePeriodo(id) {
      let datos = { Id: id };
      this.$alert.alertConfirm(
        {
          action:"eliminar",
          obj:"el periodo de cobro",
          route:'MBS-Periodos-deletePeriodo',
          data:datos,
          onSuccess:()=>{
            this.data_periodos = PeriodosCobro.getPeriodosCobroList()
            this.toggleModal(false);
          }
      })
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    this.data_periodos = PeriodosCobro.getPeriodosCobroList()
  },
};
</script>




